import { useCallback, useEffect } from 'react';
import useWhatsappLinkInfrastructure from '../infrastructure/hook/useWhatsappLinkInfrastructure';

const useWhatsappLink = () => {
    const {
        fetchLinksInfrastructure,
        clearErrorInfrastructure,
        whatsappLinksState,
    } = useWhatsappLinkInfrastructure();

    useEffect(() => {
        fetchLinks();
    }, []);

    const fetchLinks = useCallback(() => {
        fetchLinksInfrastructure();
    }, [fetchLinksInfrastructure]);

    const clearError = () => clearErrorInfrastructure();

    return { fetchLinks, clearError, data: whatsappLinksState };
};

export default useWhatsappLink;
